module.exports = __webpack_public_path__ + "static/media/cproVideo.ab44311a.jpg";